import React from 'react';

// InvoiceAttributionBadge renders a warning indicator when an invoice has
// attribution_errors set. Used inline anywhere an invoice surfaces in
// commission contexts (Commissions detail invoice list, Commission Payments
// tables, Invoice detail modal). Hover the icon to read the error.
export interface InvoiceAttributionBadgeProps {
  errors?: string | null;
  // When true, render as a compact icon-only span (table-cell mode).
  // When false (default), render with text "Attribution issue" alongside.
  iconOnly?: boolean;
  className?: string;
}

export const InvoiceAttributionBadge: React.FC<InvoiceAttributionBadgeProps> = ({
  errors,
  iconOnly,
  className,
}) => {
  if (!errors) return null;
  const cls = `text-warning${className ? ' ' + className : ''}`;
  if (iconOnly) {
    return (
      <span className={cls} title={errors} aria-label={errors}>
        <i className="bi bi-exclamation-triangle-fill" />
      </span>
    );
  }
  return (
    <span className={cls} title={errors} aria-label={errors}>
      <i className="bi bi-exclamation-triangle-fill me-1" />Attribution issue
    </span>
  );
};
